import type { NarrowedEntity } from '@adornis/baseql/utils/queryGeneration.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { LogistikProduct } from '@chancenwerk/db/LogistikProduct.js';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { g_getProductCategoryString } from '../helper.js';
/**
 * @customElement logistik-component-simple-product-item
 */
@customElement('logistik-component-simple-product-item')
export class LogistikComponentSimpleProductItem extends ChemistryLitElement {
  @property({ attribute: false }) product!:
    | LogistikProduct
    | NarrowedEntity<LogistikProduct, { _class: 1; imageID: 1; title: 1 }>;
  @property({ type: Number }) quantity?: number;
  @property({ type: String }) imageSize = '50px';

  override render() {
    return html`
      <cr-flex space-between horizontal crossaxis-center>
        <cr-flex space="sm" horizontal crossaxis-center>
          <cr-flex>
            <cr-image
              disabled
              mode="contain"
              .value=${this.product.imageID}
              ${css({ height: this.imageSize, width: this.imageSize })}
            ></cr-image>
          </cr-flex>

          <cr-flex space="sm">
            <cr-text bold> ${g_getProductCategoryString(this.product._class)} </cr-text>
            <cr-h4> ${this.product.title}</cr-h4>
          </cr-flex>
        </cr-flex>
        ${this.quantity
          ? html`
              <cr-flex horizontal crossaxis-center space="sm">
                <cr-text bold> x${this.quantity} </cr-text>
              </cr-flex>
            `
          : nothing}
      </cr-flex>
    `;
  }
}
